import { colors, fonts, borderRadius } from '../constants';

/**
 * Get base styles for helper text
 * @returns {Object} Helper text styles
 */
export const getHelperTextStyles = () => ({
  mt: '4px',
  fontSize: fonts.fontSizeSm,
  display: 'block',
  letterSpacing: '0.01em',
});

/**
 * Get input field styles
 * @param {string} field - Field name
 * @param {boolean} hasError - Whether field has error
 * @param {boolean} isFocused - Whether field is focused
 * @returns {Object} Input styles
 */
export const getInputStyle = (field, hasError = false, isFocused = false) => ({
  width: '100%',
  padding: '12px 14px',
  fontSize: fonts.fontSizeMd,
  fontFamily: fonts.fontFamily,
  backgroundColor: colors.backgroundWhite,
  color: colors.textPrimary,
  borderRadius: borderRadius.input,
  border: `1.5px solid ${hasError ? colors.error : (isFocused ? colors.primaryDark : colors.borderDefault)}`,
  minHeight: '42px',
  lineHeight: 1.4,
  transition: 'all 0.2s ease-in-out',
  outline: 'none',
  boxSizing: 'border-box',
  boxShadow: isFocused ? `0 0 0 4px ${colors.primaryTint}` : 'none',
});

/**
 * Get select field styles
 * @param {string} field - Field name
 * @param {boolean} hasError - Whether field has error
 * @param {boolean} isFocused - Whether field is focused
 * @returns {Object} Select styles
 */
export const getSelectStyle = (field, hasError = false, isFocused = false) => ({
  width: '100%',
  padding: '12px 14px',
  fontSize: fonts.fontSizeMd,
  fontFamily: fonts.fontFamily,
  backgroundColor: colors.backgroundWhite,
  color: colors.textPrimary,
  borderRadius: borderRadius.input,
  border: `1.5px solid ${hasError ? colors.error : (isFocused ? colors.primaryDark : colors.borderDefault)}`,
  minHeight: '42px',
  lineHeight: 1.4,
  transition: 'all 0.2s ease-in-out',
  outline: 'none',
  cursor: 'pointer',
  boxSizing: 'border-box',
  boxShadow: isFocused ? `0 0 0 4px ${colors.primaryTint}` : 'none',
});

/**
 * Get textarea field styles
 * @param {string} field - Field name
 * @param {boolean} hasError - Whether field has error
 * @param {boolean} isFocused - Whether field is focused
 * @returns {Object} Textarea styles
 */
export const getTextareaStyle = (field, hasError = false, isFocused = false) => ({
  width: '100%',
  padding: '12px 14px',
  fontSize: fonts.fontSizeMd,
  fontFamily: fonts.fontFamily,
  backgroundColor: colors.backgroundWhite,
  color: colors.textPrimary,
  borderRadius: borderRadius.input,
  border: `1.5px solid ${hasError ? colors.error : (isFocused ? colors.primaryDark : colors.borderDefault)}`,
  minHeight: '42px',
  lineHeight: 1.4,
  transition: 'all 0.2s ease-in-out',
  outline: 'none',
  resize: 'vertical',
  boxSizing: 'border-box',
  boxShadow: isFocused ? `0 0 0 4px ${colors.primaryTint}` : 'none',
});
